import { createContext } from 'react';
import initialTenantUsersState from './initialTenantUsersState';

const TenantUsersContext = createContext(initialTenantUsersState);

export default TenantUsersContext;
